// import “bootstrap/dist/css/bootstrap.min.css”
require('bootstrap/dist/css/bootstrap.min.css')
require('./src/styles/style.css')
// require('./src/styles/remixicon.css')
require('./src/styles/vendor/icofont/icofont.min.css')